import { Injectable } from '@angular/core';

@Injectable()
export class UploadApiService {

  constructor() { }
}
